const deliversTypSmallVariants = {
  "00": "49634523447640",
  "01": "49634523480408",
  "02": "49634523513176",
  "03": "49634523545944",
  "04": "49634523578712",
  "05": "49634523611480",
  "06": "49634523644248",
  "07": "49634523677016",
  "08": "49634523709784",
  "09": "49634523742552",
  "10": "49634523775320",
  "11": "49634523808088",
  "12": "49634523840856",
  "13": "49634523873624",
  "14": "49634523906392",
  "15": "49634523939160",
  "16": "49634523971928",
  "17": "49634524004696",
  "18": "49634524037464",
  "19": "49634524070232",
  "20": "49634524103000",
  "21": "49634524135768",
  "22": "49634524168536",
  "23": "49634524201304",
  "24": "49634524234072",
  "25": "49634524266840",
  "26": "49634524299608",
  "27": "49634524332376",
  "28": "49634524365144",
  "29": "49634524397912",
  "30": "49634524430680",
  "31": "49634524463448",
  "32": "49634524496216",
  "33": "49634524528984",
  "34": "49634524561752",
  "35": "49634524594520",
  "36": "49634524627288",
  "37": "49634524660056",
  "38": "49634524692824",
  "39": "49634524725592",
  "40": "49634524758360",
  "41": "49634524791128",
  "42": "49634524823896",
  "43": "49634524856664",
  "44": "49634524889432",
  "45": "49634524922200",
  "46": "49634524954968",
  "47": "49634524987736",
  "48": "49634525020504",
  "49": "49634525053272",
  "50": "49634525086040",
  "51": "49634525118808",
  "52": "49634525151576",
  "53": "49634525184344",
  "54": "49634525217112",
  "55": "49634525249880",
  "56": "49634525282648",
  "57": "49634525315416",
  "58": "49634525348184",
  "59": "49634525380952",
  "60": "49634525413720",
  "61": "49634525446488",
  "62": "49634525479256",
  "63": "49634525512024",
  "64": "49634525544792",
  "65": "49634525577560",
  "66": "49634525610328",
  "67": "49634525643096",
  "68": "49634525675864",
  "69": "49634525708632",
  "70": "49634525741400",
  "71": "49634525774168",
  "72": "49634525806936",
  "73": "49634525839704",
  "74": "49634525872472",
  "75": "49634525905240",
  "76": "49634525938008",
  "77": "49634525970776",
  "78": "49634526003544",
  "79": "49634526036312",
  "80": "49634526069080",
  "81": "49634526101848",
  "82": "49634526134616",
  "83": "49634526167384",
  "84": "49634526200152",
  "85": "49634526232920",
  "86": "49634526265688",
  "87": "49634526298456",
  "88": "49634526331224",
  "89": "49634526363992",
  "90": "49634526396760",
  "91": "49634526429528",
  "92": "49634526462296",
  "93": "49634526495064",
  "94": "49634526527832",
  "95": "49634526560600",
  "96": "49634526593368",
  "97": "49634526626136",
  "98": "49634526658904",
  "99": "49634526691672"
};
export {
  deliversTypSmallVariants as d
};
